export const commonConfig = Object.freeze({
  appId: 'a-006409-payonline-ui',
  sessionStorageKey: 'payonline-state',
  sessionTimeout: 1200000, // 20 mins
});
